import { render, staticRenderFns } from "./bid-form.vue?vue&type=template&id=72956299&scoped=true"
import script from "./bid-form.vue?vue&type=script&setup=true&lang=js"
export * from "./bid-form.vue?vue&type=script&setup=true&lang=js"
import style0 from "./bid-form.vue?vue&type=style&index=0&id=72956299&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72956299",
  null
  
)

export default component.exports